import { api } from './api';
import { selectors } from './selectors';
import { slice } from './slice';

interface IUserProfileStore {
  actions: typeof slice.actions;
  selectors: typeof selectors;
  api: typeof api;
}

const userProfileStore: IUserProfileStore = {
  actions: slice.actions,
  selectors,
  api,
};

export { userProfileStore };
